/**
 * @enum {typeof EnumTiposClassificacaoVolumePerigoso[keyof typeof EnumTiposClassificacaoVolumePerigoso]}
 */
export const EnumTiposClassificacaoVolumePerigoso = Object.freeze({
    361: "ONU",
    362: "CR"
});
